import React from "react";
import "../Techbody/Techbody.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import htmlimg from "../Assets/html.png";
import cssimg from "../Assets/css.png";
import jsimg from "../Assets/javascript.png";
import reactimg from "../Assets/react.png";
import angimg from "../Assets/angular.png";
import vueimg from "../Assets/vuejs.png";
import javaimg from "../Assets/java.png";
import phpimg from "../Assets/php.png";
import cimg from "../Assets/c.png";
import nodeimg from "../Assets/nodejs.png";
import rubyimg from "../Assets/ruby.png";
import pythonimg from "../Assets/python.png";
import iosimg from "../Assets/ios.png";
import andimg from "../Assets/android.png";
import fluimg from "../Assets/flutter.png";
import sqlimg from "../Assets/sql.png";
import psqlimg from "../Assets/postgresql.png";
import oracleimg from "../Assets/oracle.png";
import awsimg from "../Assets/aws.png";
import azureimg from "../Assets/azure.png";
import herokuimg from "../Assets/heroku.png";

const Techbody = () => {
  return (
    <section className="bg-light pt-3">
      {/* frontend part */}
      <div className="text-center">
        <h2 className="py-4">Frontend Technologies</h2>

        <Container>
          <Row className="justify-content-center gx-4">
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2  bg-white techbody-col">
                <img src={htmlimg} alt="" />
                <h4>HTML</h4>
                <p className="text-content ">
                  HTML stands for HyperText Markup Language. It is the most
                  basic building block of the Web. It defines the meaning and
                  structure of web content using special elements called tags.
                  HTML uses tags to annotate text, images, links, and other
                  content for display in a Web browser. HTML also allows you to
                  use other technologies such as CSS and JavaScript to enhance
                  the appearance and functionality of your web pages. The
                  current standard is HTML5
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className=" mb-3">
              <div className="border border-2 bg-white techbody-col">
                <img src={cssimg} alt="" />
                <h4>CSS</h4>
                <p className="text-content ">
                  CSS stands for Cascading Style Sheets. It is a style sheet
                  language that is used to specify the presentation and styling
                  of a document written in a markup language such as HTML or
                  XML. CSS allows you to apply different styles to HTML
                  elements, such as colors, fonts, layouts, animations, and
                  more. CSS can also be used to create responsive web design,
                  which adapts to different screen sizes and devices.CSS works
                  by using selectors to target HTML elements and applying
                  declarations
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col">
                <img src={jsimg} alt="" />
                <h4>Javascript</h4>
                <p className="text-content ">
                  JavaScript is a scripting or programming language that allows
                  you to create dynamic and interactive web pages. It can run on
                  both the browser and the server, and it supports multiple
                  paradigms such as imperative, declarative, and object-oriented
                  programming. JavaScript has a lightweight, interpreted, and
                  single-threaded nature, and it can work with other web
                  technologies such as HTML and CSS. JavaScript has a standard
                  library of built-in objects, such as Array, Date, String ect.
                </p>
              </div>
            </Col>

            <Col sm={12} md={6} lg={4} className="mb-3">
              <div className="border border-2 bg-white techbody-col">
                <img src={angimg} alt="" />
                <h4>Angular</h4>
                <p className="text-content ">
                  Angular is a TypeScript-based web application framework that
                  supports full-stack development for building all types of web
                  applications. It has a component-based architecture that
                  allows you to create reusable and modular UI elements. It also
                  provides a collection of well-integrated libraries that cover
                  various features, such as routing, forms, testing, and more.
                  Angular is open-source and maintained by Google and a large
                  community of developers.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col">
                <img src={reactimg} alt="" />
                <h4>React</h4>
                <p className="text-content ">
                  React is a JavaScript library for creating user interfaces. It
                  lets you build web pages using components, which are reusable
                  pieces of code that can display data, handle events, and
                  interact with other components. React uses a special syntax
                  called JSX, which allows you to write HTML-like code in
                  JavaScript. React also uses a virtual DOM, which is a fast and
                  efficient way of updating the browser without reloading the
                  page. React is open-source and maintained by Facebook.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col">
                <img src={vueimg} alt="" />
                <h4>VueJs</h4>
                <p className="text-content ">
                  Vue.js is a JavaScript framework for building user interfaces.
                  It extends standard HTML with a template syntax that allows
                  you to declaratively describe HTML output based on JavaScript
                  state. It also has a reactive system that automatically
                  updates the DOM when the state changes. Vue.js has a
                  component-based architecture that lets you create reusable and
                  modular UI elements. Vue.js is open-source and maintained by a
                  large community of developers.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* backend part */}

      <div className="container-fluid bg-white text-center">
        <h2 className="py-4">Backend Technologies</h2>

        <Container>
          <Row className="justify-content-center gx-4">
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2  techbody-col">
                <img src={javaimg} alt="" />
                <h4>Java</h4>
                <p className="text-content ">
                  Java is a programming language that is designed to have as few
                  implementation dependencies as possible. It is a class-based,
                  object-oriented language that supports multiple paradigms such
                  as imperative, functional, and concurrent programming. Java
                  applications are compiled to bytecode that can run on any Java
                  virtual machine (JVM) regardless of the underlying platform.
                  Java has a standard library of built-in objects and functions.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className=" mb-3">
              <div className="border border-2  techbody-col">
                <img src={pythonimg} alt="" />
                <h4>Python</h4>
                <p className="text-content ">
                  Python is a programming language that is designed to be easy
                  to read and write. It is a general-purpose language, meaning
                  it can be used for various types of applications, such as web
                  development, data analysis, automation, and more. Python is
                  dynamically typed and garbage-collected, meaning it does not
                  require declaring variables and memory management. Python
                  supports multiple programming paradigms, such as
                  object-oriented, functional programming.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2  techbody-col">
                <img src={cimg} alt="" />
                <h4>C#</h4>
                <p className="text-content ">
                  C# is a programming language that is designed to have as few
                  implementation dependencies as possible. It is a class-based,
                  object-oriented language that supports multiple paradigms such
                  as imperative, functional, and concurrent programming. C#
                  applications are compiled to bytecode that can run on any Java
                  virtual machine (JVM) regardless of the underlying platform.
                  C# has a standard library of built-in objects and functions,
                  and it also allows creating custom objects and functions.
                </p>
              </div>
            </Col>

            <Col sm={12} md={6} lg={4} className="mb-3">
              <div className="border border-2 techbody-col ">
                <img src={phpimg} alt="" />
                <h4>PHP</h4>
                <p className="text-content ">
                  PHP is a server-side scripting language that is designed for
                  web development. It is open-source, meaning it is free to
                  download and use. It has a simple and flexible syntax that can
                  be embedded in HTML or used with other web technologies. PHP
                  can interact with various databases, files, forms, cookies,
                  sessions, and more. PHP can also generate dynamic and
                  interactive web content, such as images, PDFs, or XML. PHP was
                  created by Rasmus Lerdorf in 1993.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2 techbody-col">
                <img src={nodeimg} alt="" />
                <h4>Node.js</h4>
                <p className="text-content ">
                  Node.js is a JavaScript runtime environment that allows you to
                  run JavaScript code outside of a web browser. It is
                  open-source and cross-platform, meaning it can run on various
                  operating systems and devices. Node.js uses the V8 JavaScript
                  engine, the same one used by Google Chrome, to execute
                  JavaScript code fast and efficiently. Node.js has an
                  event-driven and non-blocking architecture, meaning it can
                  handle many concurrent requests.
                </p>
              </div>
            </Col>
            <Col sm={12} md={6} lg={4} className="mb-3 ">
              <div className="border border-2 techbody-col">
                <img src={rubyimg} alt="" />
                <h4>Ruby</h4>
                <p className="text-content ">
                  Ruby is a programming language that is designed to be easy to
                  read and write. It is a general-purpose language, meaning it
                  can be used for various types of applications, such as web
                  development, data analysis, automation, and more. Ruby is
                  dynamically typed and garbage-collected, meaning it does not
                  require declaring variables and memory management. Ruby
                  supports multiple programming paradigms, such as
                  object-oriented, functional, and procedural programming.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* mobile technologies part */}
      <div className="container-fluid bg-light text-center pb-5">
        <h2 className="py-4">Mobile Technologies</h2>

        <Container>
          <Row className="justify-content-center gx-4">
            <Col sm={12} md={12} lg={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col ">
                <img src={iosimg} alt="" />
                <h4>iOS</h4>
                <p className="text-content ">
                  iOS is a mobile operating system developed by Apple Inc.
                  exclusively for its smartphones. It was unveiled in January
                  2007 for the first-generation iPhone, and it is the operating
                  system that powers many of the company’s mobile devices,
                  including the iPhone, iPad, iPod Touch, and Apple TV. iOS is
                  based on macOS, and it uses a multi-touch graphical user
                  interface that allows users to interact with their devices
                  using gestures such as swiping, tapping, and pinching
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} lg={4} className=" mb-3">
              <div className="border border-2 bg-white techbody-col ">
                <img src={andimg} alt="" />
                <h4>Android</h4>
                <p className="text-content ">
                  Android is a mobile operating system based on a modified
                  version of the Linux kernel and other open-source software. It
                  is designed primarily for touchscreen devices such as
                  smartphones and tablets. It is developed by Google and a
                  consortium of developers known as the Open Handset Alliance.
                  Android allows users to customize their devices with various
                  apps and games from the Google Play Store or other sources.
                  Android also supports various features,
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} lg={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col">
                <img src={fluimg} alt="" />
                <h4>Flutter</h4>
                <p className="text-content ">
                  Flutter is a cross-platform framework that allows you to
                  create native and web applications using a single codebase. It
                  is developed by Google and uses the Dart programming language.
                  Flutter has a component-based architecture that lets you
                  create reusable and modular UI elements called widgets.
                  Flutter also has a hot reload and hot restart feature that
                  enables fast and easy development and testing. Flutter is
                  open-source and has a large and active community of
                  developers.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* database part */}
      <div className="container-fluid bg-white text-center">
        <h2 className="py-4">Databases</h2>

        <Container>
          <Row className="justify-content-center gx-4">
            <Col sm={12} md={12} lg={4} className="mb-3 ">
              <div className="border border-2 techbody-col ">
                <img src={sqlimg} alt="" />
                <h4>MySQL</h4>
                <p className="text-content ">
                  MySQL is a popular open-source relational database management
                  system (RDBMS). It is widely used for managing and storing
                  structured data. MySQL uses SQL (Structured Query Language)
                  for database management. It supports various data types,
                  including numeric, text, date, and binary. MySQL offers high
                  performance, scalability, and reliability for large-scale
                  applications. It provides features such as transactions,
                  indexing, and stored procedures for efficient data
                  manipulation. MySQL is compatible with many programming
                  languages and platforms, making it versatile. It is commonly
                  used in web development for powering dynamic websites and
                  applications. MySQL offers robust security features to protect
                  data integrity and confidentiality.
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} lg={4} className=" mb-3">
              <div className="border border-2 techbody-col ">
                <img src={psqlimg} alt="" />
                <h4>PostgreSQL</h4>
                <p className="text-content ">
                  PostgreSQL, often referred to as Postgres, is a powerful
                  open-source relational database management system. It offers
                  robust features for handling large datasets and complex
                  queries efficiently. Known for its reliability, scalability,
                  and extensibility, PostgreSQL is trusted by enterprises and
                  startups alike. With support for advanced SQL features, it
                  enables complex data manipulation and analysis. PostgreSQL
                  also provides support for JSON, XML, and other data formats,
                  making it versatile for modern application development. Its
                  ACID compliance ensures data integrity and reliability,
                  crucial for mission-critical applications. PostgreSQL's active
                  community and frequent updates ensure ongoing improvements and
                  security enhancements. It's compatible with various platforms,
                  including Linux, Windows, and macOS, offering flexibility in
                  deployment. PostgreSQL supports advanced indexing techniques
                  for optimizing query performance, enhancing scalability.
                  Whether for small projects or enterprise-level applications,
                  PostgreSQL remains a top choice for robust and scalable
                  database solutions
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} lg={4} className="mb-3 ">
              <div className="border border-2 techbody-col ">
                <img src={oracleimg} alt="" />
                <h4>Oracle</h4>
                <p className="text-content ">
                  My Oracle is a comprehensive database management system
                  renowned for its robustness and versatility. With a rich array
                  of features and tools, it's favored by businesses worldwide
                  for managing critical data. From large enterprises to small
                  businesses, Oracle offers scalable solutions tailored to
                  diverse needs. Its advanced security features ensure data
                  integrity and protection against breaches. With Oracle,
                  organizations can streamline operations, optimize performance,
                  and enhance decision-making. Its user-friendly interface and
                  extensive documentation make it accessible even to novice
                  users. Oracle's cloud offerings provide flexibility and
                  scalability, enabling seamless adaptation to evolving business
                  needs. Backed by reliable support and continuous innovation,
                  Oracle remains a trusted choice for businesses seeking
                  reliable data management solutions
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* cloud technologies part */}
      <div className="container-fluid bg-light text-center pb-5">
        <h2 className="py-4">Cloud Services</h2>

        <Container>
          <Row className="justify-content-center gx-4">
            <Col sm={12} md={12} lg={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col ">
                <img src={awsimg} alt="" />
                <h4>Aws</h4>
                <p className="text-content ">
                  AWS services offer scalable, secure, and reliable cloud
                  solutions. Leveraging AWS, I ensure seamless infrastructure
                  management and optimal performance. With AWS, I deliver robust
                  computing power, storage, and database services tailored to
                  your needs. Experience high availability and fault tolerance
                  with AWS's resilient architecture. Utilize AWS's comprehensive
                  suite of services for flexible and cost-effective solutions.
                  From compute and storage to machine learning and analytics,
                  AWS covers all your cloud requirements. Ensure data security
                  and compliance with AWS's advanced security features and
                  certifications. Drive innovation and accelerate time-to-market
                  with AWS's agile development tools and services. Scale
                  effortlessly to meet growing demands and optimize costs with
                  AWS's pay-as-you-go pricing model. Trust in my expertise to
                  maximize the potential of AWS and propel your business
                  forward.
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} lg={4} className=" mb-3">
              <div className="border border-2 bg-white techbody-col">
                <img src={azureimg} alt="" />
                <h4>Azure</h4>
                <p className="text-content ">
                  Azure, Microsoft's cloud computing platform, offers a wide
                  range of services for building, deploying, and managing
                  applications. It provides flexible solutions for computing,
                  storage, networking, and databases, catering to diverse
                  business needs. With Azure, users can scale resources
                  dynamically, paying only for what they use. The platform
                  supports various programming languages, frameworks, and tools,
                  enabling seamless development and integration. Azure's robust
                  security measures and compliance certifications ensure data
                  protection and regulatory compliance. It also offers AI and
                  machine learning services for advanced analytics and insights.
                  Azure's global presence with data centers across regions
                  ensures low latency and high availability. The platform
                  facilitates hybrid cloud deployments, allowing seamless
                  integration with on-premises infrastructure. Organizations can
                  leverage Azure for digital transformation initiatives, driving
                  innovation and agility. With Azure, businesses gain a
                  competitive edge by harnessing the power of the cloud
                </p>
              </div>
            </Col>
            <Col sm={12} md={12} lg={4} className="mb-3 ">
              <div className="border border-2 bg-white techbody-col ">
                <img src={herokuimg} alt="" />
                <h4>HEROKU</h4>
                <p className="text-content ">
                  Heroku is a cloud platform that enables developers to deploy,
                  manage, and scale applications effortlessly. It supports
                  various programming languages like Ruby, Java, Node.js,
                  Python, and more. With Heroku, developers can focus on
                  building their apps without worrying about infrastructure
                  management. The platform offers seamless integration with
                  popular development tools and services. Heroku's scalable
                  architecture allows applications to handle traffic spikes with
                  ease. Developers can deploy apps quickly using Heroku's
                  Git-based workflow. Automatic scaling and robust monitoring
                  ensure optimal performance and reliability. Heroku provides a
                  range of add-ons for enhancing application functionality, such
                  as databases, caching, and logging services. Its user-friendly
                  dashboard offers insights into app performance and resource
                  usage. Overall, Heroku simplifies the deployment and
                  management of web applications, making it a popular choice
                  among developers.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default Techbody;
